import { subclass } from '@arcgis/core/core/accessorSupport/decorators';
import { JepGroupLayer } from '@jeppesen-foreflight/jmkw-types';
import { TwcMixin } from '../../twc.mixin';
import { Type } from '@angular/core';

// the string in the @subclass defines what value Class.name will return. Only the string past the last '.' is returned. The others are for orgaization and unqiueness.
@subclass('jmkw.layers.TwcGroupLayer')
export class TwcGroupLayer extends TwcMixin<Type<JepGroupLayer>>(
  JepGroupLayer
) {}
